import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import AddressForm from "./AddressForm";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh",
  overflowY: "auto",
};

const AddressModal = ({ isOpen, onClose, onSubmit, formData, setFormData, errors }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();
    await onSubmit();

  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2" className="mb-4">
          Yeni Adres Ekle
        </Typography>
        <AddressForm
          formData={formData}
          errors={errors}
          handleChange={handleChange}
          handleSubmit={handleAddressSubmit} // OnSubmit'i handleAddressSubmit'e bağladık
          showSameAsDelivery={true}
        />
        <div className="flex justify-end">
          <button type="submit" className="btn-primary" onClick={handleAddressSubmit}>
            Adres Ekle
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default AddressModal;
